module.exports = __webpack_public_path__ + "img/icoRefielectric.70dd17bc.png";